import React, { Component } from 'react';
import gql from 'graphql-tag';
import client from '../client';


export const LoggedInContext = React.createContext(false);
export const LogInContext = React.createContext(() => ({}));
export const LogOutContext = React.createContext(() => ({}));
export const RegisterContext = React.createContext(() => ({}));
export const AuthFunctionsContext = React.createContext({});

export const IsLoggedIn = LoggedInContext.Consumer;
export const LogIn = LogInContext.Consumer;
export const LogOut = LogOutContext.Consumer;
export const Register = RegisterContext.Consumer;
export const AuthFunctions = AuthFunctionsContext.Consumer;

export const getAuthToken = () => localStorage.getItem('authToken');

class Auth extends Component {
  constructor() {
    super();
    this.authTokenFlag = 'authToken';
    this.authToken = localStorage.getItem(this.authTokenFlag);
    this.state = { authToken: this.authToken };
    client.query({ query: gql`{ currentUser { id } }` }).catch((error) => {
      if (error && this.isAuthenticated()) {
        if (error.message.includes('Invalid token')) {
          console.warn('logout');
          this.logout();
        }
      }
    });
  }

  async login({ email, password }) {
    const { data: { login: token } } = await client.mutate({
      mutation: gql`
    mutation login($email: String!, $password: String!) {
      login(email: $email, password: $password)
    }`,
      variables: { email, password },
    });
    this.authToken = token;
    localStorage.setItem(this.authTokenFlag, token);
    client.resetStore();
    this.setState({ authToken: token });
  }

  async changePassword({ token, password }) {
    const { data: { changePassword: loginToken } } = await client.mutate({
      mutation: gql`
    mutation changePassword($token: String!, $password: String!) {
      changePassword(token: $token, password: $password)
    }`,
      variables: { token, password },
    });
    this.authToken = loginToken;
    localStorage.setItem(this.authTokenFlag, loginToken);
    client.resetStore();
    this.setState({ authToken: loginToken });
  }

  async resetPassword({ email }) {
    return await client.mutate({
      mutation: gql`
    mutation resetPassword($email: String!) {
      resetPassword(email: $email)
    }`,
      variables: { email },
    });
  }

  async register({ email, password }) {
    const { data: { register: token } } = await client.mutate({
      mutation: gql`
    mutation register($email: String!, $password: String!) {
      register(email: $email, password: $password)
    }`,
      variables: { email, password },
    });
    this.authToken = token;
    localStorage.setItem(this.authTokenFlag, token);
    client.resetStore();
    this.setState({ authToken: token });
  }

  logout() {
    this.authToken = null;
    localStorage.removeItem(this.authTokenFlag);
    client.resetStore();
    this.setState({ authToken: null });
  }

  isAuthenticated() {
    return this.authToken !== null;
  }

  getAuthToken() {
    return this.authToken;
  }

  render() {
    return (
      <LoggedInContext.Provider value={!!this.state.authToken}>
        <LogInContext.Provider value={this.login.bind(this)}>
          <LogOutContext.Provider value={this.logout.bind(this)}>
            <RegisterContext.Provider value={this.register.bind(this)}>
              <AuthFunctionsContext.Provider value={{
                logout: this.logout.bind(this),
                resetPassword: this.resetPassword.bind(this),
                changePassword: this.changePassword.bind(this),
                login: this.login.bind(this),
              }}
              >
                {this.props.children}
              </AuthFunctionsContext.Provider>
            </RegisterContext.Provider>
          </LogOutContext.Provider>
        </LogInContext.Provider>
      </LoggedInContext.Provider>
    );
  }
}


export { Auth as AuthProvider };



// WEBPACK FOOTER //
// ./src/auth/Auth.js